/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
import { getUserInfo } from './user-services';
import { openAppLogin, isApp } from '@web3/base-utils';

import * as React from 'react';
import { useEffect, useState, useContext, useCallback } from 'react';
export * from './types';
import { IUserInfo } from './types';

/**
 * React Context for UserInfo
 */
export const UserInfoContext = React.createContext({
  userInfo: undefined,
  isLogin: false,
  isFetch: false,
  handleLogin: () => {
    return;
  },
  setUserInfo: () => {
    return;
  },
});

UserInfoContext.displayName = 'UserInfoContext';

interface UserInfoProviderProps {
  children: React.ReactNode;
}

export const UserInfoProvider = (props: UserInfoProviderProps) => {
  const { children } = props;
  const [userInfo, setUserInfo] = useState<IUserInfo>();
  const [isFetch, setFetch] = useState(false);

  // 为了保证app和web的数据一致性，每次都是通过http请求获取用户信息，app的token会从js bridge中获取
  const fetchUserInfo = useCallback(() => {
    const fetch = async () => {
      try {
        setFetch(true);
        const { code, result } = await getUserInfo();
        if (code === 0) {
          setUserInfo(result);
        }
      } catch (err) {
        console.error('UserInfoProvider error', err);
      } finally {
        setFetch(false);
      }
    };
    fetch();
    return;
  }, []);

  const handleLogin = () => {
    // 防止误触
    if (userInfo && userInfo.id > 0) {
      return;
    }

    if (isApp()) {
      return openAppLogin();
    } else {
      return window.$wujie?.bus.$emit('login');
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  return (
    <UserInfoContext.Provider
      value={{
        userInfo,
        isLogin: !!(userInfo && userInfo.id > 0),
        isFetch,
        setUserInfo: fetchUserInfo,
        handleLogin,
      }}
    >
      {children}
    </UserInfoContext.Provider>
  );
};
/**
 * Custom React Hooks
 */
export const useUserInfo = () => {
  const context = useContext(UserInfoContext);
  return context;
};

export default UserInfoContext;
